const LoggingService = {
  log (message) {
    if (process.env.NODE_ENV !== 'production') {
      /* eslint-disable no-console */
      console.log(message)
      /* eslint-enable no-console */
    }
  },

  error (message) {
    if (process.env.NODE_ENV !== 'production') {
      /* eslint-disable no-console */
      console.error(message)
      /* eslint-enable no-console */
    }
  },

  debug (message) {
    if (process.env.NODE_ENV !== 'production') {
      /* eslint-disable no-console */
      console.debug(message)
      /* eslint-enable no-console */
    }
  },

  info (message) {
    if (process.env.NODE_ENV !== 'production') {
      /* eslint-disable no-console */
      console.info(message)
      /* eslint-enable no-console */
    }
  },

  time (label) {
    if (process.env.NODE_ENV !== 'production') {
      /* eslint-disable no-console */
      console.time(label)
      /* eslint-enable no-console */
    }
  },

  timeEnd (label) {
    if (process.env.NODE_ENV !== 'production') {
      /* eslint-disable no-console */
      console.timeEnd(label)
      /* eslint-enable no-console */
    }
  },

  count (label) {
    if (process.env.NODE_ENV !== 'production') {
      /* eslint-disable no-console */
      console.count(label)
      /* eslint-enable no-console */
    }
  }
}

export default LoggingService
